import { render } from "./SupportBot.vue?vue&type=template&id=5845f0e3&scoped=true"
import script from "./SupportBot.vue?vue&type=script&scoped=true&lang=js"
export * from "./SupportBot.vue?vue&type=script&scoped=true&lang=js"

import "./SupportBot.vue?vue&type=style&index=0&id=5845f0e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5845f0e3"]])

export default __exports__